import { LoadingState } from '../components/ui/Primitives';
import React, { useEffect } from 'react';
import { useParams, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import "./VerifyAccount.css"
import { logEvent } from '../utils/logger';
import { rememberCompletedSignup } from '../utils/openaiAdPixel';


function VerifyAccount({ checkLogin, login }) {
  const { verifyToken } = useParams();
  const navigate = useNavigate();
  const hasAuthenticatedSession = Boolean(checkLogin?.());
  
  useEffect(() => {
    
    // A returning user has already completed verification. Do not replay the
    // one-time activation token; continue the existing session into onboarding.
    if (hasAuthenticatedSession || !verifyToken) return;

    const event = {
      event: {
        label: 'PageView',
        data: {
          page: 'Email Verified',
          user_id: null
        }
      }

    }

    logEvent(event);

      axios.get(`${process.env.REACT_APP_BACKEND_HOST}/activate-user/${verifyToken}`)
      .then(response => {
        if (response.status === 200) {
          // Both email and Google signups complete only after successful activation.
          rememberCompletedSignup();
          login(response.data.token, true);

        } else {
          // Handle error
          console.error("Token verification failed");
          navigate('/');
        }
      })
      .catch(err => {
        console.error("Token verification failed", err);
        navigate('/');
      });
  }, [hasAuthenticatedSession, login, navigate, verifyToken]);

  if (hasAuthenticatedSession) {
    return <Navigate to="/onboarding" replace />;
  }
  
  return (
    <div>
      <div className='page-content verify-account-content'>
      { !verifyToken ? 
        <div className='page-title'>
          One more step! <br />
          <br />
          Please verify your account,
          by clicking the link we just emailed you. <br />
          <br />
          (remember to check your spam :)
        </div> : (
          <section className="verify-account-loading" role="status" aria-live="polite">
            <span className="verify-account-loading-mark" aria-hidden="true" />
            <span className="verify-account-eyebrow">Welcome to Sayable</span>
            <h1>Verifying your email</h1>
            <LoadingState label="Preparing your onboarding…" />
          </section>
        )}
      </div> 
    </div>
  );
}

export default VerifyAccount;
